//  Copyright (c) 2014 Readium Foundation and/or its licensees. All rights reserved.
//
//  Redistribution and use in source and binary forms, with or without modification,
//  are permitted provided that the following conditions are met:
//  1. Redistributions of source code must retain the above copyright notice, this
//  list of conditions and the following disclaimer.
//  2. Redistributions in binary form must reproduce the above copyright notice,
//  this list of conditions and the following disclaimer in the documentation and/or
//  other materials provided with the distribution.
//  3. Neither the name of the organization nor the names of its contributors may be
//  used to endorse or promote products derived from this software without specific
//  prior written permission.

import IndexedDBDataManager from '@axisnow/storage/IndexedDBDataManager';

var _dataManager = new IndexedDBDataManager('LibraryDataStore', manageConflict);

var getCurrentUser;

var LibraryManager = function(userManager) {
  getCurrentUser = userManager.getCurrentUser;
};

// Private API
function makeBookInfo(isbn, emptyBookInfo) {
  return getCurrentUser().then(function(user) {
    var uuid = user.bookvaultId;
    emptyBookInfo.uuid_isbn = uuid + '|' + isbn;
     /**
     * Kidzone profileid added
     */
    emptyBookInfo.uuid_profile_isbn = uuid + '|' + user.currentProfileId + '|' + isbn;
    emptyBookInfo.profileid = user.currentProfileId;
    emptyBookInfo.uuid = uuid;
    emptyBookInfo.isbn = isbn;
    emptyBookInfo.downloaded = false;
    return saveBookInfoToStorage(emptyBookInfo).then(function() {
      return emptyBookInfo;
    });
  });
}

function getBookInfoFromStorage(isbn) {
  if (!isbn) {
    throw new Error('getBookInfoFromStorage: no isbn provided');
  }
  return getCurrentUser()
    .then(function(user) {
      var uuid_profile_isbn = user.bookvaultId + '|' + user.currentProfileId + '|' + isbn;
      return _dataManager.get('uuid_profile_isbn', uuid_profile_isbn);
    })
    .then(function(bookInfo) {
      if (bookInfo && bookInfo.isbn) {
        return bookInfo;
      } else {
        return makeBookInfo(isbn, bookInfo);
      }
    })
    .catch(function(error) {
      console.error('Failed to get book info from storage');
      throw error;
    });
}

function getBookInfosFromStorage(index, value) {
  return _dataManager.getAll(index, value).catch(function(error) {
    console.error('getBookInfosFromStorage error', error);
  });
}

function saveBookInfoToStorage(bookInfo) {
  return _dataManager.put('uuid_profile_isbn', bookInfo.uuid_profile_isbn, bookInfo).catch(function(error) {
    console.error('saveBookInfoToStorage error', error);
  });
}

function manageConflict(bookInfo1, bookInfo2) {
  var update1 = bookInfo1._meta.updateTime;
  var update2 = bookInfo2._meta.updateTime;

  var date1 = new Date(update1);
  var date2 = new Date(update2);

  if (date1 > date2) {
    return bookInfo1;
  } else {
    return bookInfo2;
  }
}

// Public API

LibraryManager.prototype.getBookInfo = function(isbn) {
  return getBookInfoFromStorage(isbn);
};

LibraryManager.prototype.getBookInfosWithIndex = function(index, value) {
  return getBookInfosFromStorage(index, value);
};

LibraryManager.prototype.saveBookInfo = function(bookInfo) {
  return saveBookInfoToStorage(bookInfo);
};

LibraryManager.prototype.deleteBookInfo = function(isbn) {
  return getBookInfoFromStorage(isbn).then(function(bookInfo) {
    bookInfo.downloaded = false;
    return _dataManager.remove('uuid_profile_isbn', bookInfo.uuid_profile_isbn, bookInfo).catch(function(error) {
      console.error('deleteBookInfo error', error);
    });
  });
};

export default LibraryManager;
